import React, { useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';

import { ContainedButton, OutlinedButton } from '../../../../components/modules/Buttons';
import CrossIcon from '../../../../assets/icons/cross.svg';
import Modal from '../../../../components/modules/Modal';
import styles from './CancelRequestHelpModal.module.scss';
import { getMyUserInfo, postCancelRequestHelp } from '../../../../api';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { saveUser } from '../../../../store/user/userSlice';

type TLoginModal = {
  open: boolean;
  switchModal: () => void;
};

const CancelRequestHelpModal: React.FC<TLoginModal> = ({ open, switchModal }) => {
  const notification = useSnackbar();
  const dispatch = useAppDispatch();
  const { currentUser } = useAppSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const onClose = () => {
    setLoading(false);
    switchModal();
  };

  const onSubmit = async () => {
    if (loading) return;
    try {
      setLoading(true);
      await postCancelRequestHelp();
      notification.showMessage('Help request is canceled');
      const userJson = await getMyUserInfo();
      if (userJson?.data) {
        dispatch(saveUser(userJson.data));
      }
      onClose();
    } catch (err) {
      console.log(err);
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={loading ? onClose : () => {}} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalHeader}>
          <div className={styles.modalTitle}>Are you sure you want to cancel your request on Support?</div>
          <img src={CrossIcon} alt="close modal" onClick={onClose} className={styles.closeIcon} />
        </div>
        <div className={styles.modalSubTitle}>
          Your last request was: <br /> "{currentUser?.need_help}"
        </div>

        <div className={styles.saveBtnContainer}>
          <ContainedButton onClick={onSubmit} disabled={loading}>
            Yes, cancel
          </ContainedButton>
          <OutlinedButton kind="default" onClick={onClose} disabled={loading}>
            No
          </OutlinedButton>
        </div>
      </div>
    </Modal>
  );
};

export default CancelRequestHelpModal;
